import http from "src/utils/http";

export class Processor {
  constructor(user) {
    this.user = user;
  }

  async getLists() {
    let { data } = await http.get(
      `/api/integrations/integration/mailerlite/get-groups/${this.user?.id}`,
      {
        params: {
          id: this.user?.id,
          organization_id: this.user?.organization?.id,
        },
      }
    );

    return data;
  }
}
